import styles from './Spinner.module.css'

interface SpinnerProps {
  size?: 'sm' | 'md'
  className?: string
}

export default function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <span
      className={[styles.spinner, size === 'sm' && styles.sm, className].filter(Boolean).join(' ')}
      role="status"
      aria-label="Loading"
    />
  )
}

export function SpinnerCenter() {
  return (
    <div className={styles.wrap}>
      <Spinner />
    </div>
  )
}
